module.exports = __webpack_public_path__ + "img/LichtetDenAnker.5844ea49.jpg";